var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block time-clock"},[_c('svg-icon',{staticClass:"w-20",attrs:{"iconClass":"time","className":"time-clock-icon"}}),_c('span',[_vm._v(_vm._s(_vm.time))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }